import React, { Component } from "react";
import "styled-components/macro";

import isSafari from "./utils/is-safari";

export default class KeyboardKey3D extends Component {
  state = {
    isGlowing: false,
  };
  size = 100;
  animationMs = 350;
  animationGlowMs = this.animationMs;
  animationGlowDelayMs = this.animationMs * 0.25;
  linearGradient = `linear-gradient(#7979ff, #d6d6ea)`;
  render() {
    return (
      <div
        css={`
          z-index: ${this.props.zIndex};
          position: absolute;
          top: ${this.props.top}px;
          left: ${this.props.left}px;
          transform: scale(${this.props.scale || 1})
            rotateZ(${this.props.rotateZ || 0}deg);
          opacity: ${this.props.opacity || 1};
        `}
      >
        {/* KEYBOARD KEY */}
        <div
          css={`
            position: absolute;
            width: ${this.size * 0.87}px;
            height: ${this.size}px;
            top: 50%;
            transform-style: preserve-3d;
            transform: rotateX(220deg) rotateY(-17deg) rotateZ(-166deg)
              translateZ(${this.calcZ(this.props.hasReceivedSimulatedPress)}px);
            transition: transform ${this.animationMs}ms
              cubic-bezier(0.68, -0.3, 0.32, 1.1);
          `}
        >
          {/* LEFT SIDE */}
          <div
            css={`
              position: absolute;
              top: 0;
              left: 0;
              width: ${this.size * 0.97}px;
              height: 106%;
              transform: translateZ(-68px) rotateX(87deg) rotateY(89.3deg)
                rotateZ(0deg) translateX(70px) translateY(1px);
              filter: ${this.calcFilter(this.state.isGlowing)};
              transform-origin: right;
              background: ${this.linearGradient};
              transition: filter ${this.animationGlowMs}ms ease-out
                ${!this.state.isGlowing
                ? `${this.animationGlowDelayMs}ms`
                : "0ms"};
            `}
          />
          {/* FRONT SIDE */}
          <div
            css={`
              position: absolute;
              top: 0;
              left: 0;
              width: 97%;
              height: 106%;
              transform: rotateX(75deg) translateX(-6px) translateY(17px);
              filter: ${this.calcFilter(this.state.isGlowing)};
              transform-origin: bottom;
              background: ${this.linearGradient};
              transition: filter ${this.animationGlowMs}ms ease-out
                ${!this.state.isGlowing
                ? `${this.animationGlowDelayMs}ms`
                : "0ms"};
            `}
          />
          {/* TOP SIDE */}
          <div
            css={`
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              transform: translateZ(-100px);
              border-radius: 11px;
              background-color: ${this.props.hasReceivedSimulatedPress ? "#5c5cfb" : "#fcfcfc"};
              transition: background-color ${this.animationMs * 0.5}ms ease-out
                ${this.animationMs * 0.5}ms;
            `}
          />
        </div>
        {/* HIDING MASK */}
        <div
          css={`
            position: absolute;
            width: ${this.size}px;
            height: ${this.size}px;
            top: 50%;
            transform-style: preserve-3d;
            transform: rotateX(220deg) rotateY(-17deg) rotateZ(-166deg);
          `}
        >
          {/* LEFT SIDE */}
          <div
            css={`
              position: absolute;
              top: 0;
              left: 0;
              width: ${this.size}px;
              height: 100%;
              transform: translateZ(-100px) rotateY(98deg) translateY(-7px);
              transform-origin: right;
              background: hsl(240 11% 95% / 1);
            `}
          />
          {/* FRONT SIDE */}
          <div
            css={`
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 133%;
              transform: rotateX(82deg) translateX(15px) translateY(9px)
                rotateZ(1.5deg);
              transform-origin: bottom;
              background: hsl(240 11% 95% / 1);
            `}
          />
          {/* CORNER SIDE */}
          <div
            css={`
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              transform: rotateZ(40deg) rotateY(105deg) translateX(-1px);
              transform-origin: bottom;
              background: hsl(240 11% 95% / 1);
            `}
          />
        </div>
      </div>
    );
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.hasReceivedSimulatedPress !== this.props.hasReceivedSimulatedPress &&
      this.props.hasReceivedSimulatedPress &&
      !this.state.isGlowing
    )
    {
      setTimeout(this.props.keyPressUpAll, `${this.animationMs}`);
      this.setState({ isGlowing: true })
      return
    }
    if (prevState.isGlowing !== this.state.isGlowing && this.state.isGlowing)
    {
      setTimeout(() => {
        this.setState({ isGlowing: false });
      }, this.animationGlowMs + this.animationGlowDelayMs);
    }
  }
  calcZ = (hasReceivedSimulatedPress) => {
    if (!hasReceivedSimulatedPress) return -(this.size * 0.45);
    else if (hasReceivedSimulatedPress) return -17;
  };
  calcFilter = (isGlowing) => {

    const pressed = 'grayscale(0) brightness(1) contrast(1)'
    const notPressed = isSafari() ? 'grayscale(0.9) brightness(2.5) contrast(0.4)' : 'grayscale(0.9) brightness(1.5) contrast(0.95)'

    return isGlowing
      ? pressed
      : notPressed
  };
}
